import React from 'react';
import ntc from 'ntc';
import StonesStore from './../../stores/stonesStore';

import * as Misc from './../../misc';

const FILTER_GROUPS = StonesStore.FILTER_GROUPS;

export default (props) => {
  const isSelected = props.isSelected;
  const color = props.color;

  let o = ntc.value(Misc.toCamelCase(color));
  o = o ? Misc.toColor(o | 0xFF000000) : null;

  let filterGroups = StonesStore.getFilterGroups();
  let filter = (filterGroups && filterGroups[FILTER_GROUPS.COLOR]) && filterGroups[FILTER_GROUPS.COLOR].Values.filter(f => f.DisplayText.toLowerCase().trim() == color.toLowerCase().trim()) || [];
  if(filter.length > 0 && filter[0].Value.toLowerCase().trim() != color.toLowerCase().trim()) {
    o = filter[0].Value;
  }

  const style = {
    backgroundColor: o || color
  };
  const className = 'filter-color-names ' + (isSelected ? 'filter-color-names-selected' : '');

  return (
    <div className={className} style={style} onClick={e => Misc.ignore(e, () => props.click(props.color))}>
      <div className="filter-color-names-title">{color}</div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/stones/filterColorItemWithText.js